import { render, staticRenderFns } from "./ModalPriceOptions.vue?vue&type=template&id=521a516b&scoped=true&"
import script from "./ModalPriceOptions.vue?vue&type=script&lang=js&"
export * from "./ModalPriceOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a516b",
  null
  
)

export default component.exports